import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { Tax } from '../models/tax';
import { TaxDialogComponent } from './dialogs/tax-dialog/tax-dialog.component';
import { TaxService } from '../services/tax.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';

import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tax',
  templateUrl: './tax.component.html',
  styleUrls: ['./tax.component.scss'],
  entryComponents: [
    TaxDialogComponent
  ]
})
export class TaxComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['icon', 'name', 'value', 'edit', 'delete'];

  constructor(
    private _taxService: TaxService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    private router: Router
  ) {

    if (!this._authService.isAdmin) {
      this.router.navigate(['home']);
    }

    this.loadTaxs()
  }

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadTaxs() {

    this.sub = this._taxService.select()
      .subscribe((result) => {
        let array = result.map(item => {
          let entity = new Tax();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.value = item.payload.doc.data().value;

          return entity;
        });

        setTimeout(() => {
          this.dataSource = new MatTableDataSource(array);
          this.dataSource.sort = this.sort;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(entity) {

    let data: Tax = new Tax();

    if (entity) {
      data = entity;
    }

    this.dialog.open(TaxDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  delete(element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.name + "<br><br>Excluir esta Taxa?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._taxService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete tax error: " + error.message) }
          )
      }
    })
  }

}
